import { combineReducers } from 'redux';
import userActionTypes from '@/rdx/actionTypes';
import { actionDialogReducer } from '@/rdx/reducers/actionDialogReducer';
import { addInteraction } from '@/rdx/reducers/add-interaction';
import { announcements } from '@/rdx/reducers/announcements';
// eslint-disable-next-line import/no-cycle -- TODO: Fix this the next time the file is edited.
import { authentication } from '@/rdx/reducers/authentication';
import { campaignDonationsReducer } from '@/rdx/reducers/campaignDonationsReducer';
import { campaignReducer } from '@/rdx/reducers/campaignReducer';
import { campaigns } from '@/rdx/reducers/campaigns';
import { companyTeamMembers } from '@/rdx/reducers/company-team-members';
import { donations } from '@/rdx/reducers/contributions';
import { interactions } from '@/rdx/reducers/interactions';
import { inviteForm } from '@/rdx/reducers/invite-form';
import { invites } from '@/rdx/reducers/invites';
import { newDonation } from '@/rdx/reducers/new-donation';
import { orgList } from '@/rdx/reducers/org-list';
import { publicUsers } from '@/rdx/reducers/public-users';
import { registration } from '@/rdx/reducers/registration';
import { removeCampaign } from '@/rdx/reducers/removeCampaign';
import { resendVerification } from '@/rdx/reducers/resend-verification';
import { resetPassword } from '@/rdx/reducers/reset-password';
import { resetPasswordSubmit } from '@/rdx/reducers/reset-password-submit';
import { sendingInvites } from '@/rdx/reducers/sending-invites';
import { updateCampaign } from '@/rdx/reducers/updateCampaign';
import { updateCampaignFiscalGoalReducer } from '@/rdx/reducers/updateCampaignFiscalGoalReducer';
import { updateMultipleCampaigns } from '@/rdx/reducers/updateMultipleCampaigns';
import { updatingCompanyTeamMembers } from '@/rdx/reducers/updating-company-team-members';
import { updatingInvites } from '@/rdx/reducers/updating-invites';
import { user } from '@/rdx/reducers/user';
import { usersList } from '@/rdx/reducers/users-list';
import { visitStreak } from '@/rdx/reducers/visit-streak';

const appReducer = combineReducers({
  actionDialog: actionDialogReducer,
  addInteraction,
  announcements,
  authentication,
  campaign: campaignReducer,
  campaignDonations: campaignDonationsReducer,
  campaigns,
  companyTeamMembers,
  donations,
  interactions,
  inviteForm,
  invites,
  newDonation,
  orgList,
  publicUsers,
  registration,
  removeCampaign,
  resendVerification,
  resetPassword,
  resetPasswordSubmit,
  sendingInvites,
  updateCampaign,
  updateCampaignFiscalGoal: updateCampaignFiscalGoalReducer,
  updateMultipleCampaigns,
  updatingCompanyTeamMembers,
  updatingInvites,
  user,
  usersList,
  visitStreak,
});

export default function reducer(state, action) {
  return appReducer(
    action.type === userActionTypes.LOGOUT ? undefined : state,
    action,
  );
}
